<app-navbar-style-two *ngIf="dynamicStatus" aria-label="Main navigation"></app-navbar-style-two>

<!-- Loading indicator with SEO improvements -->
<div align="center" *ngIf="gifLoader" aria-live="polite" aria-busy="true">
  <img height="200" width="200"
       src="https://medeilpos.blob.core.windows.net/posimage/loading.gif"
       alt="Loading Medeil content, please wait"
       loading="lazy"
       role="status">
</div>

<main *ngIf="!gifLoader && pageData" itemscope itemtype="https://schema.org/WebPage">
  <!-- Hero Section with Schema Markup -->
  <section itemprop="mainContentOfPage">
    <div class="container">
      <div class="cs_cta text-center position-relative" [ngStyle]="{'background': pageData?.main_color || '#000'}">
        <div class="cs_cta_in" itemprop="hasPart" itemscope itemtype="https://schema.org/WPHeader">
          <div class="cs_section_heading cs_style_1">
            <h1 class="cs_section_title cs_text_white" itemprop="headline">{{ pageData.banner_header }}</h1>
            <p class="cs_section_subtitle mb-0" itemprop="description">{{ pageData.banner_sub_content }}</p>
          </div>
          <div class="cs_btn_group text-center">
            <a *ngIf="pageData.cta_button_one && !pageData.togglecontrol"
               [href]="pageData.cta_button_link_one"
               class="cs_btn cs_bg_white"
               [ngStyle]="{'color': pageData.sub_color}"
               itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
               <span itemprop="name">{{ pageData.cta_button_name_one }}</span>
            </a>
            <a *ngIf="pageData.cta_button_one && pageData.togglecontrol"
               (click)="openLandingpage(pageData.lead_source_name)"
               class="cs_btn cs_bg_white"
               [ngStyle]="{'color': pageData.sub_color}"
               itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
               <span itemprop="name">{{ pageData.cta_button_name_one }}</span>
            </a>
            <a *ngIf="pageData.cta_button_two && !pageData.togglecontrol_cta_2"
               [href]="pageData.cta_button_link_two"
               class="cs_btn cs_bg_accent"
               [ngStyle]="{'background': pageData.sub_color, 'border-color': pageData.sub_color}"
               itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
               <span itemprop="name">{{ pageData.cta_button_name_two }}</span>
            </a>
            <a *ngIf="pageData.cta_button_two && pageData.togglecontrol_cta_2"
               (click)="openLandingpage(pageData.lead_source_name_cta_2)"
               class="cs_btn cs_bg_accent"
               [ngStyle]="{'background': pageData.sub_color, 'border-color': pageData.sub_color}"
               itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
               <span itemprop="name">{{ pageData.cta_button_name_two }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section with Schema Markup -->
  <section class="cs_business_feature position-relative" id="features"
           itemprop="mainEntity" itemscope itemtype="https://schema.org/ItemList">
    <div class="container">
      <div class="cs_section_heading cs_style_1 text-center">
        <h2 class="cs_section_title1" itemprop="name">{{ pageData.feature_heading }}</h2>
      </div>
      <div class="row justify-content-center">
        <div *ngFor="let feature of pageData.feature; let i = index"
             class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex mt-3"
             itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <div class="cs_iconbox cs_style_1 w-100" itemprop="item" itemscope itemtype="https://schema.org/Thing">
            <meta itemprop="position" [content]="i+1">
            <div class="cs_iconbox_icon" aria-hidden="true">
              <i class="fa" [ngClass]="feature.feature_icon || 'fa-shopping-cart'"
                 [ngStyle]="{'color': pageData.sub_color}"></i>
            </div>
            <h3 class="cs_iconbox_title" itemprop="name">{{ feature.feature_sub_heading }}</h3>
            <p class="cs_iconbox_subtitle" itemprop="description">{{ feature.feature_description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Content Section -->
  <section class="cs_faq_wrap position-relative" id="faq">
    <div class="container">
      <div class="feature-content-wrapper" [innerHTML]="pageData.feature_content"
           itemprop="text"></div>
      <div class="cs_section_heading cs_style_1 text-center">
        <h2 class="cs_section_title1 mb-0" itemprop="name">{{ pageData.faq_heading }}</h2>
      </div>
      <div class="row">
        <div class="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div class="cs_accordian_wrap" itemscope itemprop="mainEntity" itemtype="https://schema.org/FAQPage">
            <div *ngFor="let faq of pageData.faq; let i = index"
                 class="cs_accordian"
                 [class.active]="activeIndex === i"
                 itemprop="mainEntity" itemscope itemtype="https://schema.org/Question">
              <h4 class="cs_accordian_title"
                  (click)="toggleFAQ(i)"
                  itemprop="name"
                  [attr.aria-expanded]="activeIndex === i ? 'true' : 'false'"
                  [attr.aria-controls]="'faq-answer-' + i"
                  role="button"
                  tabindex="0">
                {{ faq.quetion }}
                <span class="cs_accordian_toggle" [class.rotate]="activeIndex === i" aria-hidden="true"></span>
              </h4>
              <div class="cs_accordian_body"
                   [id]="'faq-answer-' + i"
                   [style.display]="activeIndex === i ? 'block' : 'none'"
                   itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer">
                <div itemprop="text">{{ faq.answer }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section with Schema Markup -->
  <section itemprop="mainEntity" itemscope itemtype="https://schema.org/WPAdBlock">
    <div class="container">
      <div class="bottom_cta_panel" [ngStyle]="{'background': pageData?.main_color || '#000'}">
        <div class="left-content cs_text_white" itemprop="description">
          <p>{{ pageData?.bottom_cta_description }}</p>
        </div>
        <div class="right-button">
          <a *ngIf="!pageData.togglecontrol_cta_3"
            [href]="pageData?.bottom_cta_button_link"
            class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData?.sub_color, 'border-color': pageData?.sub_color}"
            itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
            <span itemprop="name">{{ pageData?.bottom_cta_button_name }}</span>
          </a>
          <a *ngIf="pageData.togglecontrol_cta_3"
            (click)="openLandingpage(pageData.lead_source_name_cta_3)"
            class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData?.sub_color, 'border-color': pageData?.sub_color}"
            itemprop="potentialAction" itemscope itemtype="https://schema.org/Action">
            <span itemprop="name">{{ pageData?.bottom_cta_button_name }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer-style-two *ngIf="dynamicStatus" aria-label="Footer navigation"></app-footer-style-two>